'use strict';

/* global $ */

function Scroll(options) {

    let opt = $.extend(true, {
    }, options);

    function initBlock(selector) {
        let $el = $(selector);

        console.log('[ Scroll/Init ]');
        
        $el.on('click', function(e) {
            let href = $(this).attr('href');
            let id = href.split('#').pop();
            if ($('#' + id).length) {
                let offset = $('#' + id).offset().top;
                e.preventDefault();
                $('html, body').animate({ scrollTop: offset }, 1000);
            }
        });
    }

    initBlock(opt.selector);
}

export {
    Scroll
};
